<template>
	<div class="header-cart" v-if="hasItems()">
		<div class="level-item level-right">
			<router-link to="/checkout" class="button button--cart">
				<mq-layout mq="desktop">
					<span class="item-count">
						<span class="item-count-text">View Cart ({{ itemCount }})</span>
					</span>
				</mq-layout>
				<mq-layout :mq="['mobile', 'tablet']">
					<div class="item-count-background">
						<span class="item-count">
							{{ itemCount }}
						</span>
					</div>
				</mq-layout>
				<BaseIcon :classNames="{icon: true}" icon="cartIcon" size="lg"/>
			</router-link>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { CART } from '@/stores/defs';

	export default {
		computed: { 
			...mapGetters({
				itemCount: CART.ITEM_COUNT,
			}),
		},
		methods: {
			hasItems() {
				if (this.itemCount > 0) {
					return true;
				}
				return false;
			}
		},
	}
</script>

<style lang="scss">
	@import 'globalStyles';
	.header-cart {
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
	
		margin-bottom: 0;

		width: 100%;
		height: $navigationBarHeight;

		background-color: $checkoutButtonColor;

		.button--cart {
			display: flex;
			justify-content: space-evenly;
			
			margin-right: 0.75rem;
			border-radius: 3em;
			border-style: none;
			
			width: 200px;
			height: auto;
			

			color: $checkoutButtonColor;
			font-weight: 600;

			&.router-link-active {
				div {
					background-color: transparent;
					color: $storeTextColor;
				}
			}

			.item-count-background {
				display: flex;
				justify-content: center;
				align-items: center;
				
				border-radius: 50%;
				
				width: 1.66rem;
				height: 1.66rem;
			}
			
			.icon {
				position: relative;
				top: 3px;
				right: 5px;
			}
		}
	}

	@include mobile {
		.header-cart {
			.button--cart {
				flex-direction: row-reverse;
				justify-content: start;

				width: 4.6em;

				.item-count-background {
					position: relative;
					left: 0.55rem;

					background-color: $checkoutButtonColor;
				}

				.item-count {
					color: white;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/header/HeaderCart.vue